import {
    MAP_GEOFENCES_UNITS_SEARCH,
    MAP_GEOFENCES_UNITS_SEARCH_RESPONSE,
    CLEAR_REDUX
} from 'Redux/actionTypes';

const INIT_STATE = {
    open: false,
    unitGeofence: [],
    loadingResponse: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        

        case MAP_GEOFENCES_UNITS_SEARCH:
            return {
                ...state,
                unitGeofence: [],
                loadingResponse: true
            };

        case MAP_GEOFENCES_UNITS_SEARCH_RESPONSE:
            return {
                ...state,
                unitGeofence: action.payload.data,
                loadingResponse: false
            };

        case CLEAR_REDUX:
            return ["", "MAP_GEOFENCE_UNIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return { ...state };
    }
}